define('SuiteDynamics.PLPThreePanelBanner.Banner.View',
	[
		'Backbone',
		'underscore',
		'suitedynamics_plpthreepanelbanner_banner.tpl'
	],
	function (
		Backbone,
		_,
		suitedynamics_plpthreepanelbanner_banner_tpl
	)
{
	'use strict';

	return Backbone.View.extend({
		template: suitedynamics_plpthreepanelbanner_banner_tpl,

		initialize: function (options) {
			var environment = options.container.getComponent('Environment');
			this.configuration = environment.getConfig('plpThreePanelBanner');

			this.plpComponent = options.container.getComponent('PLP');

			this.showCategoryBanner = false;
			this.evaluateShowCategoryBanner();
		},

		evaluateShowCategoryBanner: function() {
			var categoryInfo = this.plpComponent.getCategoryInfo();
			if (categoryInfo && categoryInfo.internalid) {
				var categoryConfiguration = _.find(this.configuration.categoryPromoBanner, function (categoryConfig) {
					return categoryConfig.categoryId.toLowerCase() === categoryInfo.internalid.toLowerCase();
				});

				if (categoryConfiguration) {
					this.showCategoryBanner = true;
					this.firstImageUrl = categoryConfiguration.firstImageUrl;
					this.firstImageAlt = categoryConfiguration.firstImageAlt || '';
					this.secondImageUrl = categoryConfiguration.secondImageUrl;
					this.secondImageAlt = categoryConfiguration.secondImageAlt || '';
					this.thirdImageUrl = categoryConfiguration.thirdImageUrl;
					this.thirdImageAlt = categoryConfiguration.thirdImageAlt || '';

					this.render();
				}
			}
		},

		getContext: function() {
			return {
				showCategoryBanner: this.showCategoryBanner,
				firstImageUrl: this.showCategoryBanner && this.firstImageUrl,
				firstImageAlt: this.firstImageAlt,
				secondImageUrl: this.secondImageUrl,
				secondImageAlt: this.secondImageUrl,
				thirdImageUrl: this.thirdImageUrl,
				thirdImageAlt: this.thirdImageAlt
			}
		}
	});
});
